export default {
  viewAccountCTA: {
    href: '/myatc/my_summary.xhtml'
  },
  logOutCTA: {
    label: 'Sign Out'
  },
  logInCTA: {
    label: 'Sign In'
  },
  signUpCTA: {
    label: 'Sign Up'
  },
  editMyAdCTA: {
    href: '/sell-my-car/manage-ad',
    label: 'Manage My Ad'
  },
  privateSellerCTA: {
    href: '/marketplace/dashboard',
    label: 'Private Seller Center',
    target: '_blank'
  },
  viewMessagesCTA: {
    href: '/marketplace/notifications',
    label: 'Messages',
    target: '_blank'
  },
  dashboardCTA: {
    href: '/account/dashboard',
    label: 'My Dashboard'
  },
  carsCTA: {
    href: '/account/cars',
    label: 'Saved Listings'
  },
  mySearchesCTA: {
    href: '/account/searches',
    label: 'My Saved Searches'
  },
  myCarsCTA: {
    href: '/account/mycars',
    label: 'My Cars'
  },
  settings: {
    href: '/account/profile',
    label: 'Profile'
  }
};